const color = {
  primary: '#0356DD',
  lightGray: '#FAFAFA',
  redSox: '#BD3039',
  purple: '#660198',
  green: '#2E8B57',
}

export default color
